import css from 'styled-jsx/css';

const styles = css.global`#banner-disclaimer p {
  font-family: "SantanderText";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  color: #222;
  margin-top: 20px;
  text-align: center;
}`;

export default styles;